import { Handle, Position } from "@xyflow/react";
import { useDispatch, useSelector } from "react-redux";
import { ungroupNode, updateNode } from "../../utils/flowSlice";
import axios from "./../../utils/axiosInstance";
import { useEffect, useState } from "react";
import { BiLoaderCircle } from "react-icons/bi";
import { FaRegObjectUngroup } from "react-icons/fa6";
import toast from "react-hot-toast";

const DocuemntNode = ({ data, isConnectable }) => {
  const dispatch = useDispatch();
  const nodes = useSelector((store) => store.flow.nodes);
  const currentNode = nodes.find((node) => node.id === data.id);
  const isGrouped = !!currentNode ? !!currentNode.parentId : false;
  const [loading, setLoading] = useState(false);
  const [title, setTitle] = useState(data.title || "Fetching the title");
  const unGroup = () =>
    dispatch(
      ungroupNode({
        id: data.id,
      })
    );

  const script = data.script;
  let tempTitle;
  const fetchTitle = async (script) => {
    try {
    } catch (err) {
      if (err.status === 402) {
        toast.error(
          "You have run out of your credit. You need to upgrade your plan"
        );
      }
    }
    if (title !== "Fetching the title") return;
    if (!!script) {
      setLoading(true);
      const response = await axios.post(
        `${process.env.REACT_APP_BASED_URL}/service/title`,
        {
          script,
        }
      );
      tempTitle = response.data;
    } else {
      tempTitle = "No content";
    }

    setLoading(false);
    setTitle(tempTitle);
    dispatch(
      updateNode({
        id: data.id,
        data: {
          ...data,
          title: tempTitle,
        },
      })
    );
  };

  useEffect(() => {
    fetchTitle(script);
  }, []);

  // const fileContent
  return (
    <div className="text-updater-node">
      <Handle
        type="source"
        position={Position.Right}
        isConnectable={isConnectable}
        style={{
          width: "20px", // Default width
          height: "20px", // Default height
          background: "white", // Default background color
          border: "2px solid #32b5e5", // Default border color
          borderRadius: "50%", // Circular shape
          position: "absolute",
          right: "-20px", // Ensure proper alignment
          // top: "50%", // Align vertically
          transform: "translateY(-50%)", // Center the handle
          display: "flex",
          alignItems: "center",
          lineHeight: "20px", // Match the handle's height for vertical centering
          fontSize: "12px", // Ensure text size fits
          justifyContent: "center",
          transition: "transform 0.2s, background-color 0.2s, right 0.2s", // Smooth hover transition
        }}
        onMouseEnter={(e) => {
          e.target.style.transform = "translateY(-50%) scale(1.5)"; // Keep alignment and scale
          e.target.style.background = "#32b5e5"; // Change background to blue
          e.target.style.color = "white"; // Set text color to white
          e.target.innerHTML = "+"; // Add "+" symbol inside
        }}
        onMouseLeave={(e) => {
          e.target.style.transform = "translateY(-50%) scale(1)"; // Reset scale while maintaining alignment
          e.target.style.background = "white"; // Reset background to white
          e.target.style.color = ""; // Clear the text color
          e.target.innerHTML = ""; // Remove "+" symbol
        }}
      />

      <div
        className="w-[375px] h-[150px] mx-auto bg-gray-300 rounded-[15px] shadow-md border-[4px] border-transparent transition-colors duration-300 focus-within:border-[#e9ad91]"
        tabIndex="0"
      >
        <div className="h-[35px] flex justify-between items-center text-white px-4 py-2 rounded-t-[12px] bg-[#F5A397]">
          <div className="flex items-center space-x-2">
            {isGrouped && (
              <FaRegObjectUngroup
                size={"16"}
                className="hover:cursor-pointer"
                onClick={() => unGroup()}
              />
            )}
            {loading ? (
              <div className="flex items-center justify-start">
                <BiLoaderCircle
                  size={"18"}
                  className="loading-icon"
                  color="white"
                />
                <span className="ml-2 flex justify-start font-semibold text-xs">
                  Fetching the title
                </span>
              </div>
            ) : (
              <div className="ml-2 font-semibold text-xs text-left overflow-hidden text-nowrap overflow-ellipsis w-[250px]">
                <span className="text-[16px]">📝</span>
                <span className="ml-2 font-semibold text-sm">{title}</span>
              </div>
            )}
          </div>
        </div>

        <div className="w-full h-[107px] flex items-center justify-center bg-white p-4 rounded-b-[12px] shadow-inner">
          <span className="text-xl">📄 </span>
          <span className="text-gray-700 font-medium text-xl">
            {data.file || "No file"}
          </span>
        </div>
      </div>
    </div>
  );
};

export default DocuemntNode;
